export const k = {
    noteLabel: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.components.invoice-text.invoice-text-i18n.noteLabel",
    feeStatementLabel: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.components.invoice-text.invoice-text-i18n.feeStatementLabel",
    invoiceRegardingLabel: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.components.invoice-text.invoice-text-i18n.invoiceRegardingLabel"
};
export const translations = {
    da: {
        noteLabel: "Notat",
        feeStatementLabel: "Fakturatekst",
        invoiceRegardingLabel: "Faktura vedrørende"
    },
    en: {
        noteLabel: "Note",
        feeStatementLabel: "Invoice text",
        invoiceRegardingLabel: "Invoice regarding"
    }
};
